import { FC } from 'react';
import { OfferAlertWrapper } from '../OfferAlert/OfferAlert.styles';
import { Copy } from '../../styles/Typography';
import { CONTAINER_STATE, CONTAINER_TEST_ID } from '../OfferAlert/constants';
import CONTENT from './content.json';

interface IOfferAlertErrorState {
  offerId: string;
}

export const ErrorState: FC<IOfferAlertErrorState> = ({ offerId }) => {
  return (
    <OfferAlertWrapper data-testid={CONTAINER_TEST_ID} data-state={CONTAINER_STATE.ERROR} data-offerid={offerId}>
      <Copy>{CONTENT.errorMessage}</Copy>
    </OfferAlertWrapper>
  );
};

ErrorState.displayName = 'OfferAlert_ErrorState';
